import { Regular } from '../text'
import styles from './style.styl'
import vml from '../../assets/images/logos/vml.png'
import bmw from '../../assets/images/logos/bmw.svg'
import apple from '../../assets/images/logos/apple.svg'
import dff from '../../assets/images/logos/dff.png'
import frog from '../../assets/images/logos/frog.svg'
import mercedes from '../../assets/images/logos/mercedes.svg'
import netflix from '../../assets/images/logos/netflix.svg'
import orange from '../../assets/images/logos/orange.svg'
import wpp from '../../assets/images/logos/wpp.svg'

const LOGOS = [
  {
    imageSrc: vml,
    name: 'vml'
  },
  {
    imageSrc: bmw,
    name: 'bmw'
  },
  {
    imageSrc: frog,
    name: 'frog'
  },
  {
    imageSrc: apple,
    name: 'apple'
  },
  {
    imageSrc: wpp,
    name: 'wpp'
  },
  {
    imageSrc: mercedes,
    name: 'mercedes'
  },
  {
    imageSrc: orange,
    name: 'orange'
  },
  {
    imageSrc: dff,
    name: 'dff'
  },
  {
    imageSrc: netflix,
    name: 'netflix'
  }
]

const firstRowMobile = [
  {
    imageSrc: netflix,
    name: 'netflix'
  },
  {
    imageSrc: bmw,
    name: 'bmw'
  },
  {
    imageSrc: frog,
    name: 'frog'
  },
  {
    imageSrc: mercedes,
    name: 'mercedes'
  },
  {
    imageSrc: vml,
    name: 'vml'
  }

]
const secondRowMobile = [
  {
    imageSrc: orange,
    name: 'orange'
  },
  {
    imageSrc: apple,
    name: 'apple'
  },
  {
    imageSrc: wpp,
    name: 'wpp'
  },
  {
    imageSrc: dff,
    name: 'dff'
  }
]

const LogosRow = () => {
  return (
    <section className={styles.logos}>
      <Regular className={styles.title}>Our delegates work at:</Regular>
      <div className={styles.row}>
        {LOGOS.map(logo =>
          <img src={logo.imageSrc} alt={logo.name} className={styles[`${logo.name}`]} />
        )}
      </div>
      <div className={styles.rowsMobile}>
        <div className={styles.rowMobile}>
          {firstRowMobile.map(logo =>
            <img src={logo.imageSrc} alt={logo.name} className={styles[`${logo.name}`]} />
          )}
        </div>
        <div className={styles.rowMobileSecond}>
          {secondRowMobile.map(logo =>
            <img src={logo.imageSrc} alt={logo.name} className={styles[`${logo.name}`]} />
          )}
        </div>
      </div>
    </section>
  )
}

export default LogosRow



// WEBPACK FOOTER //
// ./components/logos-row/index.js